<template>
  <v-card flat class="outline">
    <!-- Render: switch -->
    <checklist-input-switch
      v-if="(/switch/).test(type)"
      :index="index"
      :label="label"
      :description="description"
      :translation="translation"
      :validations="validations"
      :default="result"
      :length="length"
      @value="setValue"
      @note="setNote"
    ></checklist-input-switch>
    <!-- Render: number -->
    <checklist-input-number
      v-if="(/number/).test(type)"
      :index="index"
      :label="label"
      :description="description"
      :translation="translation"
      :validations="validations"
      :default="result"
      :source="source"
      :length="length"
      @value="setValue"
      @note="setNote"
    ></checklist-input-number>
    <!-- Render: string -->
    <checklist-input-string
      v-if="(/string/).test(type)"
      :index="index"
      :label="label"
      :description="description"
      :translation="translation"
      :validations="validations"
      :default="result"
      :length="length"
      @value="setValue"
      @note="setNote"
    ></checklist-input-string>
    <!-- Render: image -->
    <checklist-input-image
      v-if="(/file/).test(type)"
      :index="index"
      :label="label"
      :description="description"
      :translation="translation"
      :validations="validations"
      :default="result"
      @uploadImage="uploadImage"
      @removeImage="removeImage"
      @note="setNote"
    ></checklist-input-image>
    <!-- Render: graph -->
    <checklist-input-graph
      v-if="(/graph/).test(type)"
      :index="index"
      :label="label"
      :description="description"
      :translation="translation"
      :default="result"
      :source="source"
      @value="setValue"
      @note="setNote"
    ></checklist-input-graph>
    <!-- Render: fallback -->
    <checklist-fallback
      v-if="! valid && items.length"
      :level="level"
      :index="index"
      :items="items"
    ></checklist-fallback>
  </v-card>
</template>

<script>
import ChecklistInputSwitch from './checklist-input-switch.vue'
import ChecklistInputNumber from './checklist-input-number.vue'
import ChecklistInputString from './checklist-input-string.vue'
import ChecklistInputImage from './checklist-input-image.vue'
import ChecklistInputGraph from './checklist-input-graph.vue'
import ChecklistFallback from './checklist-fallback.vue'

export default {
  name: 'checklist-input',
  props: {
    level: Number,
    index: Number,
    label: String,
    description: String,
    translation: Object,
    validations: Array,
    items: Array,
    type: String,
    source: Object,
    length: String
  },
  data () {
    return {
      valid: true
    }
  },
  computed: {
    result () {
      const def = {
        value: null,
        note: null
      }
      return Object.assign(def, this.$store.getters['checklist/results'][this.index])
    },
    value () {
      return this.result.value
    }
  },
  methods: {
    setValue ({ value, valid }) {
      this.valid = valid
      this.$store.commit('checklist/setValue', {
        idx: this.index,
        value,
        valid: valid && value !== null,
        subIds: findSubIds({ items: this.items })
      })
    },
    setNote ({ note }) {
      this.$store.commit('checklist/setNote', {
        idx: this.index,
        note
      })
    },
    async uploadImage ({ data }) {
      try {
        const { id } = await this.$store.dispatch('checklist/uploadInputImage', {
          formData: data
        })

        const value = (this.value || []).concat(id)

        this.$store.commit('checklist/setValue', {
          idx: this.index,
          value: value,
          valid: value.length > 0,
          subIds: findSubIds({ items: [...this.items] })
        })
        await this.$store.dispatch('getItems', { model: { name: 'files-in-checklists-in-interventions' } })
        this.$store.commit('checklist/save')
      } catch (error) {
        console.error(error)
      }
    },
    async removeImage ({ id }) {
      try {
        const fileIn = this.$store.state.items['files-in-checklists-in-interventions']
          .filter((f) => f.fileId === id).shift()

        await this.$store.dispatch('checklist/removeInputImage', {
          id,
          fileInId: fileIn ? fileIn.id : null
        })

        const value = (this.value || []).filter(i => i !== id)

        this.$store.commit('checklist/setValue', {
          idx: this.index,
          value: value,
          valid: value.length > 0,
          subIds: findSubIds({ items: [...this.items] })
        })

        this.$store.commit('checklist/save')
      } catch (error) {
        console.error(error)
      }
    }
  },
  components: {
    ChecklistInputSwitch,
    ChecklistInputNumber,
    ChecklistInputString,
    ChecklistInputImage,
    ChecklistInputGraph,
    ChecklistFallback
  }
}

// Helpers

function findSubIds (obj) {
  let ids = []
  if (obj.items && obj.items.length) {
    for (let item of obj.items) {
      ids.push(item.idx)
      let subIds = findSubIds(item)
      if (subIds.length) {
        ids = ids.concat(subIds)
      }
    }
  }
  return ids
}
</script>
